import { put, call, takeEvery } from 'redux-saga/effects'
import { UpdateMultimediaBlockProgress } from 'api/lessons/block-instances/UpdateMultimediaBlockProgress'
import * as fromActions from '../../../actions/blockProgress.action'

async function handlePutLessonContentBlockProgress(data: any) {
  return await UpdateMultimediaBlockProgress(data.blockInstanceableId, data.courseId, data.currentTime, data.duration)
}

function* updateLessonContentBlockProgressEffectSaga(action: any) {
  try {
    const data = yield call(handlePutLessonContentBlockProgress, action.data)
    const entry = {
      blockInstanceableId: data.blockInstanceId,
      courseId: action.data.courseId,
      id: action.data.id,
      data: {
        duration: parseFloat(data.duration),
        currentTime: parseFloat(data.progress)
      }
    }

    yield put(fromActions.Actions.setLessonBlockProgressSucess(entry))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* updateLessonContentBlockProgressWatcherSaga() {
  yield takeEvery(
    fromActions.SET_LESSON_BLOCKS_PROGRESS,
    updateLessonContentBlockProgressEffectSaga
  )
}